import { useStore } from "@stores"
import { useAppContext } from "@components/AppContext"

export const indexOperation = "transactions/IndexInvestorTransactions"


const useTransactionsStore = (investorAccountId) => {
  const { request } = useAppContext()

  const shouldAutoLoad = true

  const {
    items: transactions,
    indexItems: indexTransactions
  } = useStore(indexOperation, request, shouldAutoLoad, { investorAccountId }, [ investorAccountId ])

  return {
    transactions,
    indexTransactions,
  }
}

export default useTransactionsStore
